
import Vue from "vue";
import { mapActions } from "vuex";

import TableCustom from "@/components/TableCustom.vue";
import EditIcon from "@/components/icons/EditIcon.vue";

export default Vue.extend({
  name: "ConfigurationInformationSide",
  components: { TableCustom, EditIcon },
  computed: {
    model() {
      return this.$store.getters.model;
    },
    items() {
      return this.$store.state.modelConfigurationInformation;
    },
    itemsA() {
      const datas = this.$store.state.modelConfigurationInformation;
      const halfLength = Math.ceil(datas.length / 2);

      return datas.slice(0, halfLength);
    },
    itemsB() {
      const datas = this.$store.state.modelConfigurationInformation;
      const halfLength = Math.ceil(datas.length / 2);

      return datas.slice(halfLength, datas.length);
    },
    ModelTypeName() {
      return this.$store.state.model.equipmentModelType.title;
    },
  },
  data() {
    const headers = [
      { text: "Type", value: "title", sortable: false, width: "40%" },
      { text: "Value", value: "value", sortable: false, width: "30%" },
      { text: "Unit", value: "unitCode", sortable: false, width: "30%" },
    ];

    return { headers, dialog: false };
  },
  methods: {
    ...mapActions(["getModel"]),
    async onSave() {
      try {
        const editData = this.items.filter((prev) => prev.isEdit);
        for (const data of editData) {
          await this.fetchUpdateValue(data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.dialog = false;
      }
    },
    async onClose() {
      this.dialog = false;

      const { id } = this.model;
      await this.getModel(id);
    },
    async fetchUpdateValue(data: any) {
      try {
        const { id, value } = data;
        await (this as any).$dep.modelUseCase.updateModelConfiguration(id, { value });
      } catch (error) {
        console.log(error);
      } finally {
        const index = this.items.findIndex((prev) => prev.id === data.id);
        this.items[index].isEdit = false;
      }
    },
    onChangeValue(item: any, ev: any) {
      const index = this.items.findIndex((prev) => prev.id === item.id);
      this.items[index].value = ev;
      this.items[index].isEdit = true;
    },
  },
});
